var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0067FF",
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55,7H32a2,2,0,0,0-1.41.59l-26,26a2,2,0,0,0,0,2.82l23,23a2,2,0,0,0,2.82,0l26-26A2,2,0,0,0,57,32V9A2,2,0,0,0,55,7ZM53,31.17l-24,24L8.83,35l24-24H53Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.5,
    cy: 18.5,
    r: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPricing);
export default __webpack_public_path__ + "static/media/icon-pricing.ce6edcec76230da85fecb1328455122d.svg";
export { ForwardRef as ReactComponent };